import MemoryStorage from 'memorystorage';

function fallbackStorage() {
  if (process.env.NODE_ENV !== 'test') {
    console.warn('[grab-storage]',
      'Using `MemoryStorage` due to `window.localStorage` is not supported.');
  }

  return new MemoryStorage();
}

function GrabStorage() {
  let storage = null;

  if (!storage) {
    // Occurs when it's a browser environment
    // Using global variable `__USE_MEMORY_STORAGE__` for testing purpose
    if (typeof window !== 'undefined' && !window.__USE_MEMORY_STORAGE__) {
      const KEY = `grab_storage_supported_${Math.random()}`;

      try {
        window.localStorage.setItem(KEY, 'true');

        if (window.localStorage.getItem(KEY) !== 'true') {
          throw new Error('Unable to use `window.localStorage`.');
        }

        window.localStorage.removeItem(KEY);
        storage = window.localStorage;
      } catch (err) {
        // Occurs when the browser(i.e. Safari) is in private mode.
        storage = fallbackStorage();
      }
    } else {
      // Occurs when it's a Node environment.
      storage = fallbackStorage();
    }
  }

  return storage;
}

export default new GrabStorage();



/** WEBPACK FOOTER **
 ** ../common/grab-storage/src/index.js
 **/